export default {
  modules: [],
  categories: [],
  module: {},
  lastLessons: [],
  faq: []
};
